import { dynamic_validator } from './index';

export function bank_validations(values, data) {
  if (!data) {
    return undefined;
  }
  const errors = {};
  if (!values.currency_code) {
    errors.currency_code = 'Required';
  } else {
    // local currency check only routing codes
    let validationObj = {};
    Object.keys(data).forEach((key) => {
      if (data[key] instanceof Object) {
        const field_name = data[key]['render']['value_field_name'];
        if (field_name in values) {
          if (field_name !== 'card_number' || values.is_card_number_updated !== false) {
            // call validation function and pass validation object
            validationObj = data[key]['validation'];
            dynamic_validator(field_name, values, validationObj, errors);
          }
        }
      }
    });
  }
  return errors;
}
